import { render, staticRenderFns } from "./AIimage.vue?vue&type=template&id=a720664e&scoped=true"
import script from "./AIimage.vue?vue&type=script&lang=js"
export * from "./AIimage.vue?vue&type=script&lang=js"
import style0 from "./AIimage.vue?vue&type=style&index=0&id=a720664e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a720664e",
  null
  
)

export default component.exports